import { Link } from 'react-router-dom';
import './Navbar.css'; 

export default function Navbar() {
  return (
    <nav className="navbar">


   <div className="navbar">
      <div className="nav-left">    
        
         <ul className="navbar-menu">
            <li><Link to="/" className="navbar-link">Inicio</Link></li>
          {/* <li><Link to="/login" className="navbar-link">Login</Link></li>
          <li><Link to="/register" className="navbar-link">Register</Link></li> */}
          <li><Link to="/rooms" className="navbar-link">Habitaciones</Link></li>
          <li><Link to="/about" className="navbar-link">Acerca de nosotros</Link></li>
        </ul></div>
      <div className="nav-center">
  <Link to="/">
    <img src="/IMAGOTIPO.jpg" alt="Casa Gloria Logo" width={50} className="cursor-pointer" />
  </Link>
</div>
      <div className="nav-right">
        <span>📞 +427 1 650 602</span>
        <span className="book-now"><Link to="/booking/step1" className="navbar-link">📩 Reserva ahora! </Link></span>
      </div>
    </div>

    </nav>
  );
}
